import { render, staticRenderFns } from "./AppraiserValuationPrice.vue?vue&type=template&id=355cb775&scoped=true&"
import script from "./AppraiserValuationPrice.vue?vue&type=script&lang=ts&"
export * from "./AppraiserValuationPrice.vue?vue&type=script&lang=ts&"
import style0 from "./AppraiserValuationPrice.vue?vue&type=style&index=0&id=355cb775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355cb775",
  null
  
)

export default component.exports